import { render, staticRenderFns } from "./BoneBrothRecipe.vue?vue&type=template&id=5c721091&scoped=true&"
import script from "./BoneBrothRecipe.vue?vue&type=script&lang=js&"
export * from "./BoneBrothRecipe.vue?vue&type=script&lang=js&"
import style0 from "./BoneBrothRecipe.vue?vue&type=style&index=0&id=5c721091&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c721091",
  null
  
)

export default component.exports